import { createContext, useContext, ReactNode } from 'react';

export type IntegrationType = 'shiphero';

export interface Integration {
  id: IntegrationType;
  name: string;
  logo: string;
  logoHeight: string;
  hasCredentials: boolean;
}

interface IntegrationContextType {
  integrations: Integration[];
  selectedIntegration: Integration;
  setSelectedIntegration: (integration: Integration) => void;
  updateIntegrationCredentials: (id: IntegrationType, hasCredentials: boolean) => void;
  setDefaultFromUser: (defaultIntegrationId: string) => void;
}

const IntegrationContext = createContext<IntegrationContextType | undefined>(undefined);

const shipheroIntegration: Integration = {
  id: 'shiphero',
  name: 'ShipHero',
  logo: '/shiphero_logo_cropped.svg',
  logoHeight: 'h-8',
  hasCredentials: false,
};

export function IntegrationProvider({ children }: { children: ReactNode }) {
  // ShipHero is the only integration — no selection logic needed
  const selectedIntegration = shipheroIntegration;

  return (
    <IntegrationContext.Provider value={{ 
      integrations: [shipheroIntegration], 
      selectedIntegration, 
      setSelectedIntegration: () => {},
      updateIntegrationCredentials: () => {},
      setDefaultFromUser: () => {},
    }}>
      {children}
    </IntegrationContext.Provider>
  );
}

export function useIntegration() {
  const context = useContext(IntegrationContext);
  if (!context) {
    throw new Error('useIntegration must be used within an IntegrationProvider');
  }
  return context;
}
